const TableTypes = Object.freeze({
    Open: Symbol("open"),
    Closed: Symbol("closed"),
    Updates: Symbol("updates"),
    EmailGroups: Symbol("email groups"),
    Systems: Symbol("systems")
});

export default TableTypes;